import { HITS_PER_SHOWCASE } from './algolia/constants'

export const useBoxEvents = async (
  filters: { category: string },
  itemsPerPage = HITS_PER_SHOWCASE
) => {
  const searchClient = useAlgoliaRef()
  const { locale } = useI18n()

  const boxQueryParams = [
    {
      indexName: getBoxesIndexName(locale.value),
      facetFilters: [`categories.name:${filters?.category}`],
      hitsPerPage: itemsPerPage,
    },
  ]

  const {
    data: algoliaResults,
    pending,
    status,
  } = await useLazyAsyncData(`algoliaResults-box-${process.client}`, () => {
    return searchClient.search(boxQueryParams)
  })

  return {
    algoliaResults,
    pending,
    status,
  }
}
